.blockApplicationsModesContainer {
	max-width: 100%;
	overflow-x: auto;
}

.scientificContainer {
	display: flex;
	flex-direction: row;
	gap: 0.3125rem;
	align-items: center;
	justify-content: center;

	& :global(.MuiTypography-root) {
		font-size: 14px;
	}
}

.referenceMaterialUpload {
	width: 100%;
	min-height: 80px;
}

.referenceMaterialUploadZoneContent {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	width: 100%;
}

.referenceMaterialUploadError {
	margin-top: 0.125rem;
}

.referenceMaterialFileList {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	width: 100%;
}

.referenceMaterialFileItem {
	display: flex;
	width: 100%;
}

.referenceMaterialStudentBanner {
	width: auto;
	padding: 12px;
	display: flex;
	gap: 10px;
	border: 1px solid #c0b9ec;
	border-radius: 10px;
	background-color: #f9f8ff;
	align-items: start;
	color: #42296e;

	& .svgIcon {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		height: 21px;

		& svg {
			width: 18px;
			height: 18px;
		}
	}

	& .label {
		font-weight: 400;
		font-size: 0.875rem;
		color: #333333;

		& .title {
			font-weight: 700;
			font-size: 0.875rem;
			margin-right: 4px;
		}
	}
}

.uploadContent {
	display: flex;
	align-items: center;
	gap: 16px;
}

.uploadIconCircle {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background-color: #f0ecfc;
	flex-shrink: 0;
	& svg {
		width: 20px;
		height: 20px;
		& path {
			stroke-width: 2;
			stroke: #5f557e;
		}
	}
}

.uploadActionRow {
	display: flex;
	align-items: center;
	gap: 5px;
	font-size: 15px;
	color: #5d4e79;
}

.chooseFileLink {
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	color: #0b6f85;
	text-decoration: underline;
	font-size: 15px;
	font-family: inherit;
	border-radius: 2px;

	&:hover {
		text-decoration: none;
	}

	&:focus-visible {
		outline: 2px solid #0b6f85;
		outline-offset: 2px;
	}
}
